<div class="wrapper-billing-history">
    <div class="section-main">
        <h1 class="title text-center">
            Billing History
        </h1>
    </div>

    <div class="section-history container-xl">
        <div class="table-history table-responsive mx-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th class="border-left-0 text-start" scope="col">
                            Date 
                        </th>
                        <th class="border-left-0 text-start w-40" scope="col">
                            Description
                        </th>
                        <th class="border-left-0 text-center" scope="col">
                            Amount
                        </th>
                        <th class="border-right-0 text-center" scope="col">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="border-left-0 text-start">March 27, 2021</td>
                        <td class="text-start">Paypal</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">March 01, 2021</td>
                        <td class="text-start">
                            <a class="link-invoice" href="/">
                                Invoice for February 2021
                            </a>
                        </td>
                        <td class="text-center">$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Feb 01, 2021</td>
                        <td class="text-start">Paypal</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 30, 2020</td>
                        <td class="text-start">
                            <a class="link-invoice" href="/">
                                Invoice for February 2021
                            </a>
                        </td>
                        <td class="text-center">$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 29, 2020</td>
                        <td class="text-start">Paypal</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 27, 2020</td>
                        <td class="text-start">Paypal</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 26, 2020</td>
                        <td class="text-start">Paypal</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="border-left-0 text-start">Dec 25, 2020</td>
                        <td class="text-start">Paypal</td>
                        <td class="text-center">-$25</td>
                        <td class="border-right-0 text-center">
                            <div class="section-download">   
                                <p class="section-title">Download</p>
                                <button class="btn btn-download">PDF</button>
                                <button class="btn btn-download">CSV</button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="section-cta container-xl">
        <div class="card">
            <div class="section-top">
                <img class="ellipse-yellow" src="../../assets/ellipse-yellow.png" alt="yellow">
            </div>
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                    <h4 class="card-title">FIV5S - Make You Possible</h4>
                    <p class="card-subtitle">An eco-platform app to manage your business which solves all your business challenges.</p>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-6 section-btn">
                    <button class="btn btn-create rounded-pill mb-20">
                        Setup New Store
                    </button>
                </div>
            </div>
            <div class="section-bottom">
                <img class="ellipse-blue" src="../../assets/ellipse-blue.png" alt="blue">
            </div>
        </div>
    </div>
</div>